// extracted by mini-css-extract-plugin
export default {"wrapper":"media-upload-exports-EditMediaModal__wrapper--2lCF2"};